import { Component, Vue, Prop } from "vue-facing-decorator";
import type { MessageContentSettings, MessageStructureComponent } from "../types";
import Button from "../components/button.vue";
import Img from "../components/image.vue";
import type { InlineClickAction } from '../types/inline_click_action';
import { InlineActionHandler } from '../helpers/inline-actions/inline_action_handler';
import { Util } from "../util";

declare var marked;
@Component({
    components: { Button, Img },
})
export default class Bubble extends Vue {
  //#region Component Props
  //Contains properties passed into the component

  @Prop() components?: MessageStructureComponent[];
  @Prop() structure?: Object;
  @Prop() structureSettings?: any;
  @Prop() messageContentsettings?: MessageContentSettings;
  @Prop({
		type: Object,
		default() {
			return {};
		},
	})
  inlineClickActions?: Record<string, InlineClickAction>;
  inlineActionHandler!: InlineActionHandler;

	@Prop({ type: [String, Number] })
  messageId!: string | number;



  //#endregion

  //#region Computed Properties

  get prefixClassName() {
    return this.$store.state.prefixClassName || "";
  }

  // WEBAPPS-917
	// This is used to determine if the bubble
	// has any button or links, based on that we will add class to it.
  get isBubbleHasButton(): boolean {
		return !!this.components && this.components.some((c) => c.type === "button" || c.type === "link");
	}

  // SD-1220
	// This is used to determine if the bubble
	// has any links (<a> tag with class "satisfi_link_button"), based on that we will add class to it.
  get isBubbleHasLinkButton(): boolean {
		return (
			Array.isArray(this.components) &&
			this.components.some((c) => c.type !== "text" && c.content && c.content.includes("satisfi_link_button"))
		);
	}

  // SD-13708
  // Determines whether the input content for the current message is hidden.
  get inputHidden(): boolean {
    return !!this.messageContentsettings?.inputHidden;
  }

  //#endregion

    marked(value) {
        return marked(value);
    }

    decodeTags(content: string = ''){
        return content.replace(/&amp;/g, '&').replace(/&amp;/g, '&');
    }

    // SD-13708
    // Resolves what a component should show:
    // - displayText, if it's set
    // - otherwise content, unless the input is hidden
    // - otherwise nothing
    getDisplayContent(component: MessageStructureComponent): string {
      if (!Util.isNullOrEmpty(component?.displayText)) {
        return component.displayText;
      }
      if (!this.inputHidden) {
        return component?.content || '';
      }
      return '';
    }

    //#region Lifecycle Hooks

    /**
     * Lifecycle hook: Runs after the component has been mounted to the DOM.
     * mounted() = component is in the DOM, but may not be visually complete.
     * $nextTick() = waits until Vue has finished all pending DOM updates.
     */
    mounted() {
      //@ts-ignore
      // $nextTick is used to ensure that the DOM is fully rendered before executing the function
      this.$nextTick(() => {
        this.listenEvents();
      });
    }

    /**
     * Lifecycle hook: Runs before the component is destroyed.
     */
    beforeDestroy() {
      this.removeEvents();
    }

    /**
     * Gets the HTML container element for the bubble.
     */
    get container() {
      //@ts-ignore
      return this.$refs.containerRef as HTMLElement;
    }

    /**
     * Adds event listeners to the bubble container on component mount.
     */
    listenEvents() {
      try {
        
        this.inlineActionHandler = new InlineActionHandler(this.components, this.container, this.inlineClickActions, this.messageId);
        if (!this.inlineActionHandler) return; // skip if not initialized
        if (!this.inlineActionHandler.bind || typeof this.inlineActionHandler.bind !== "function") return;
        // Bind the click event handler to the container element
        this.inlineActionHandler.bind();
      } catch (ex) {
        console.log("[bubble.ts] An error has occurred \n-> Inside listenEvents -> Error: ", ex);
      }
    }

    /**
     * Removes event listeners from the bubble container on component destruction.
     */
    removeEvents() {
      try {
        if (!this.inlineActionHandler) return; // skip if not initialized
        if (!this.inlineActionHandler.unbind || typeof this.inlineActionHandler.unbind !== "function") return;
        // Unbind the click event handler from the container element
        this.inlineActionHandler.unbind();
      } catch (ex) {
        console.log("[bubble.ts] An error has occurred \n-> Inside removeEvents -> Error: ", ex);
      }
    }

    formatMessageContent(messageContent:string){
      return Util.formatTextWithAccessibleEmojis(messageContent)
    }
    //#endregion
}
